var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPCoolingStorageSw = function SvgPCoolingStorageSw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "52.1,256 40.1,263.2 40.1,62.1 52.1,62.1",
    fill: "#FFFFFF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "42.1,262 42.1,62.1 43.1,62.1 43.1,261.4",
    fill: "#787878"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "47.1,259 45.1,260.2 45.1,62.1 47.1,62.1",
    fill: "#437FA3"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "50.1,257.2 49.1,257.8 49.1,62.1 50.1,62.1",
    fill: "#787878"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.1,252.1 296.1,252.1 284.1,264.1 52.1,264.1 47.1,259.1 47.1,257.1",
    fill: "#FFFFFF"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "47.1,257.1 291.1,257.1 289.1,259.1 47.1,259.1",
    fill: "#437FA3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "49.1,255.1 293.1,255.1 294.1,254.1 50.1,254.1",
    fill: "#787878"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "42.1,261.1 287.1,261.1 286.1,262.1 43.1,262.1",
    fill: "#787878"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "296.1,252.1 296.1,330.1 284.1,330.1 284.1,264.1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.1,257.1 291.1,330.1 289.1,330.1 289.1,259.1",
    fill: "#437FA3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.1,255.1 293.1,330.1 294.1,330.1 294.1,254.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.1,261.1 287.1,330.1 286.1,330.1 286.1,262.1",
    fill: "#787878"
  }))));
};
export default SvgPCoolingStorageSw;